import { render, staticRenderFns } from "./InvoicesTableWeb.vue?vue&type=template&id=2abdc2fa&scoped=true"
import script from "./InvoicesTableWeb.vue?vue&type=script&lang=js"
export * from "./InvoicesTableWeb.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTableWeb.vue?vue&type=style&index=0&id=2abdc2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abdc2fa",
  null
  
)

export default component.exports